import logException from './logException';
import { apiUrl } from './env';

function getRequestContext(url, options = {}) {
  try {
    const requestUrl = new URL(
      url,
      typeof window !== 'undefined' ? window.location.href : undefined,
    );

    return {
      host: requestUrl.host,
      href: requestUrl.href,
      method: options.method || 'GET',
      pathname: requestUrl.pathname,
      search: requestUrl.search,
    };
  } catch {
    return {
      href: url,
      method: options.method || 'GET',
    };
  }
}

async function parseJSON(response) {
  if (!response.ok && !response.body) {
    return null;
  }

  if (response.status === 204 || response.status === 205) {
    return true;
  }

  const json = await response.json();
  json.meta = response;

  return json;
}

export default async function request(url, token, options = {}) {
  try {
    return await fetch(url, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...(token && { 'x-access-token': token }),
        ...(options.headers && options.headers),
      },
    }).then(parseJSON);
  } catch (error) {
    const message = error?.message || '';
    const isNetworkFetchError =
      error instanceof TypeError &&
      (message === 'Failed to fetch' ||
        message.startsWith('Failed to fetch') ||
        message.includes('NetworkError') ||
        message.includes('Load failed'));

    if (isNetworkFetchError) {
      const networkError = new Error(`Network error: Failed to fetch ${url}`);
      networkError.name = 'NetworkFetchError';
      networkError.originalError = error;
      networkError.url = url;
      networkError.method = options.method || 'GET';
      networkError.requestContext = getRequestContext(url, options);
      networkError.tags = {
        error_kind: 'fetch_network_error',
        host: networkError.requestContext.host,
        method: networkError.method,
      };
      logException(networkError);
      error.message =
        'Please check your internet connection and try again. If the problem persists, please contact support.';
      throw error;
    }
    throw error;
  }
}

export async function fetcher(url, token, options = {}) {
  return fetch(apiUrl + url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token && { 'x-access-token': token }),
      ...(options.headers && options.headers),
    },
  })
    .then(parseJSON)
    .then(res => {
      if (res.data) return res.data;

      throw res.error || res.message;
    })
    .catch(error => {
      if (error?.error) {
        throw error.error;
      }

      if (error?.message) {
        throw error.message;
      }

      throw new Error(error ?? 'Unknown Error');
    });
}

export async function suspenseFetcher(url, token, options = {}) {
  return fetch(apiUrl + url, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(token && { 'x-access-token': token }),
      ...(options.headers && options.headers),
    },
  })
    .then(async response => {
      if (!response.ok && !response.body) {
        return null;
      }

      if (response.status === 204 || response.status === 205) {
        return true;
      }

      const json = await response.json();

      return json;
    })
    .then(res => {
      if (res.data) return res.data;

      return res;
    });
}
